import OptionGroupTable from '@core/components/tables/option-group-table/option-group-table.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-option-groups',
  components: {
    'bpc-option-group-table': OptionGroupTable,
  },
})
export default class OptionGroups extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
